export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10620.1efdb899.jpg";